import { PaymentMethodTypes, paymentMethodTypeEnum } from '../../../../api/vouchers/helpers';
import { alignReceiptColumns, cardReceiptLayout } from '../../../../api/vouchers/pdfBuilders/helpers';

export function getColumns(paymentMethodType: PaymentMethodTypes, paymentMethodObject?: any) {
    return alignReceiptColumns(columnsFor(paymentMethodType, paymentMethodObject));
}

function columnsFor(paymentMethodType: PaymentMethodTypes, paymentMethodObject?: any) {
    switch (paymentMethodType) {
        case paymentMethodTypeEnum.CREDIT_CARD: {
            const layout = cardReceiptLayout(paymentMethodObject);
            if (layout === 'single') {
                return [
                    { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '23%' } },
                    { title: 'Description', fieldName: 'description', style: { width: '30%' } },
                    { title: 'Value Date', fieldName: 'dueDate', style: { width: '15%' } },
                    { title: 'Amount', fieldName: 'amount', style: { width: '16%' } },
                    { title: 'Currency', fieldName: 'currency', style: { width: '16%' } }
                ];
            }
            if (layout === 'credit') {
                return [
                    { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '23%' } },
                    { title: 'Description', fieldName: 'description', style: { width: '20%' } },
                    { title: 'Value Date', fieldName: 'dueDate', style: { width: '12%' } },
                    { title: 'Credit Payments', fieldName: 'creditPayments', style: { width: '15%' } },
                    { title: 'Amount', fieldName: 'amount', style: { width: '15%' } },
                    { title: 'Currency', fieldName: 'currency', style: { width: '15%' } }
                ];
            }
            return [
                { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '23%' } },
                { title: 'Description', fieldName: 'description', style: { width: '15%' } },
                { title: 'Value Date', fieldName: 'dueDate', style: { width: '12%' } },
                { title: 'First Payment', fieldName: 'firstPayment', style: { width: '15%' } },
                { title: 'Additional Payments', fieldName: 'additionalPayments', style: { width: '15%' } },
                { title: 'Amount', fieldName: 'amount', style: { width: '10%' } },
                { title: 'Currency', fieldName: 'currency', style: { width: '10%' } }
            ];
        }
        case paymentMethodTypeEnum.BANK_TRANSFER: {
            return [
                { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '23%' } },
                { title: 'Bank', fieldName: 'bank', style: { width: '23%' } },
                { title: 'Account', fieldName: 'account', style: { width: '22%' } },
                { title: 'Value Date', fieldName: 'dueDate', style: { width: '12%' } },
                { title: 'Amount', fieldName: 'amount', style: { width: '10%' } },
                { title: 'Currency', fieldName: 'currency', style: { width: '10%' } }
            ];
        }
        case paymentMethodTypeEnum.CHECK: {
            return [
                { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '16%' } },
                { title: 'Bank', fieldName: 'bank', style: { width: '22%' } },
                { title: 'Account', fieldName: 'account', style: { width: '18%' } },
                { title: 'Value Date', fieldName: 'dueDate', style: { width: '12%' } },
                { title: 'Check #', fieldName: 'number', style: { width: '12%' } },
                { title: 'Amount', fieldName: 'amount', style: { width: '10%' } },
                { title: 'Currency', fieldName: 'currency', style: { width: '10%' } }
            ];
        }
        case paymentMethodTypeEnum.CASH: {
            return [
                { title: 'Payment Method', fieldName: 'paymentMethod', style: { width: '23%' } },
                { title: 'Description', fieldName: 'description', style: { width: '23%' } },
                { title: 'Amount', fieldName: 'amount', style: { width: '12%' } },
                { title: 'Currency', fieldName: 'currency', style: { width: '12%' } }
            ];
        }
        default:
            return [];
    }
}
